export default __webpack_public_path__ + "static/media/coursesIcon.89ed0225.svg";